// extracted by mini-css-extract-plugin
module.exports = {"section":"common_section__2MSy1","maxWidthContainer":"common_maxWidthContainer__VLZzs"};